import React from 'react';
import {compose, withProps, lifecycle} from 'recompose';
import {withScriptjs} from 'react-google-maps';
import {StandaloneSearchBox} from 'react-google-maps/lib/components/places/StandaloneSearchBox';
import confConst from '../../config/const';

const wp = withProps({
  googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${confConst.MAP.KEY}&v=3.exp&libraries=geometry,drawing,places`,
  loadingElement: (
    <div
      style={{height: `100%`}}
    />
  ),
  containerElement: (
    <div
      style={{height: `400px`}}
    />
  ),
});
const lc = lifecycle({
  componentWillMount() {
    const refs = {};

    this.setState({
      places: [],
      onSearchBoxMounted: ref => {
        refs.searchBox = ref;
      },
      onPlacesChanged: () => {
        const places = refs.searchBox.getPlaces();
        if (places && places[0] && places[0]) {
          if (places[0].geometry && places[0].geometry.location)
            this.props.onNewPlace(
              {
                address: places[0].formatted_address,
                lat: places[0].geometry.location.lat(),
                lng: places[0].geometry.location.lng()
              }
            );
        }

        // this.setState({
        //   places,
        // });
      },
    })
  },
});
const PlacesWithStandaloneSearchBox = compose(wp, lc, withScriptjs)(props => {
    return (
      <StandaloneSearchBox
        ref={props.onSearchBoxMounted}
        bounds={props.bounds}
        onPlacesChanged={props.onPlacesChanged}
      >
        <input
          type="text"
          placeholder="Enter your address"
          defaultValue={props.address}
        />
      </StandaloneSearchBox>
    )
  }
);

export default PlacesWithStandaloneSearchBox;


// WEBPACK FOOTER //
// ./src/app/components/Map/SearchBox.js